import { useEffect, useState } from 'react';
var STORAGE_KEY = '_challenge-preview';
var EVENT_NAME = 'influitive:preview-data-updated';
export var useChallengePreviewData = function useChallengePreviewData() {
  var _useState = useState(''),
      data = _useState[0],
      setData = _useState[1];

  useEffect(function () {
    function updatePreviewData() {
      var _localStorage$getItem;

      setData((_localStorage$getItem = localStorage.getItem(STORAGE_KEY)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '');
    }

    window.addEventListener(EVENT_NAME, updatePreviewData);
    return function () {
      window.removeEventListener(EVENT_NAME, updatePreviewData);
    };
  }, [setData]);
  useEffect(function () {
    var _localStorage$getItem2;

    setData((_localStorage$getItem2 = localStorage.getItem(STORAGE_KEY)) !== null && _localStorage$getItem2 !== void 0 ? _localStorage$getItem2 : '');
  });
  return data;
};